const wrapper = document.querySelector(".products-custom__wrapper")

const loadmore = document.querySelector(".products-custom__btn")
loadmore && loadmore.addEventListener("click", () => {
    const _data = document.querySelector("._products-data") || loadmore
    const query = _data.getAttribute("data-param-posts")
    const maxPages = _data.getAttribute("data-max-pages")
    const data = {
        "action": "products_loadmore_wc",
        "query": query,
        "page": this_page,
    }

    $.ajax({
        url: MyAjax.ajaxurl,
        data: data,
        type: "POST",
        success: function (data) {
            if (data) {
                wrapper.innerHTML += data;
                this_page++;
                if (this_page == maxPages) {
                    loadmore.classList.add("hidden")
                }
            } else {
                loadmore.classList.add("hidden")
            }
        }
    });
})

const sizes = document.querySelectorAll(".products-custom__size")
sizes.length && sizes.forEach(size => {
    size.addEventListener("click", () => {
        const category = wrapper.getAttribute("data-category")
        const weight = size.getAttribute("data-slug")

        sizes.forEach(inner => {
            inner.classList.remove("active")
        })
        size.classList.add("active")

        this_page = 1
        const data = {
            "action": "filter_weight",
            "slug": category,
            "weight": weight,
        }

        $.ajax({
            url: MyAjax.ajaxurl,
            data: data,
            type: "POST",
            success: function (data) {
                if (data) {
                    wrapper.innerHTML = data;
                    const _data = document.querySelector("._products-data")
                    const maxPages = _data.getAttribute("data-max-pages")

                    if (this_page == maxPages) {
                        loadmore.classList.add("hidden")
                    } else {
                        loadmore.classList.remove("hidden")
                    }
                }
            }
        });
    })
})


